import {
    MOBILE_DRAWER_OPEN,
    ACTIONS_DRAWER_IS_SHOWN,
    ACTIONS_DRAWER_IS_LOADING,
    ACTIONS_DRAWER_WRAPPER_IS_SHOWN,
    CHANGE_CONSOLE_LANGUAGE,
    CHANGE_CONTENT_LANGUAGE,
    INITIALIZE_CONTENT_LANGUAGE,
} from './constants';

export const handleDrawerToggle = (isOpened) => ({
    type: MOBILE_DRAWER_OPEN,
    payload: { isOpened },
});

export const handleActionDrawerIsShown = (isShown) => ({
    type: ACTIONS_DRAWER_IS_SHOWN,
    payload: { isShown },
});

export const handleActionDrawerIsLoading = (isLoading) => ({
    type: ACTIONS_DRAWER_IS_LOADING,
    payload: { isLoading },
});

export const handleDrawerWrapperToggle = (isShown) => ({
    type: ACTIONS_DRAWER_WRAPPER_IS_SHOWN,
    payload: { isShown },
});

export const changeConsoleLanguage = (language) => ({
    type: CHANGE_CONSOLE_LANGUAGE,
    payload: language,
});

export const initializeContentLanguage = () => ({
    type: INITIALIZE_CONTENT_LANGUAGE,
});

export const changeContentLanguage = (language) => ({
    type: CHANGE_CONTENT_LANGUAGE,
    payload: language,
});
